import { combineReducers } from 'redux'

import {
  RECEIVE_TIDES
} from '../actions/'



function stationReducer(state={}, action) {
  return state
}

function tidesReducer(state={}, action) {
  switch (action.type) {
  case RECEIVE_TIDES:
    const newTides = {}
    action.tides.forEach(tide => {
      newTides[tide.id] = tide
    })
    return {
      ...state,
      ...newTides
    }
  default:
    return state
  }
}

export default combineReducers({
  stations: stationReducer,
  tides: tidesReducer,
})



// WEBPACK FOOTER //
// ./src/reducers/entitiesReducer.js